/**
 * Line icons, drawn to match the POS the shop already uses: 1.6px strokes on a
 * 24-box, rounded caps, no fills. Every icon inherits `currentColor` so the
 * active/inactive sidebar states are pure CSS.
 */

const Svg = ({ size = 22, children, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    {children}
  </svg>
);

/* ── sidebar ─────────────────────────────────────────────────────────── */

export const IconHome = (p) => (
  <Svg {...p}>
    <path d="M3.5 10.5 12 3.5l8.5 7" />
    <path d="M5.5 9.5v9a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5v-9" />
    <path d="M9.5 20v-5.5h5V20" />
  </Svg>
);

export const IconHistory = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
    <path d="M8 3.5V6M16 3.5V6M3.5 9.5h17" />
    <path d="M7.5 13.5h9M7.5 17h5" />
  </Svg>
);

export const IconCashier = (p) => (
  <Svg {...p}>
    <path d="M4 20.5h13.5M4 20.5V9.5h9.5v11" />
    <path d="M6.5 12.5h4.5M6.5 15.5h4.5" />
    <path d="M13.5 12.5h4.5V9.5l-2-4h-8" />
  </Svg>
);

export const IconAttendance = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="3.5" />
    <path d="M5 20.5c0-3.6 3.1-6 7-6s7 2.4 7 6" />
  </Svg>
);

export const IconCommission = (p) => (
  <Svg {...p}>
    <path d="M3 17c1.6-1.4 3.4-1.4 5 0l1.2 1a3 3 0 0 0 2 .7h3.6" />
    <path d="M9.5 14.5h3.8a1.6 1.6 0 0 0 0-3.2H10a3.4 3.4 0 0 1-2.2-.8" />
    <path d="M14.8 15.2 20 12" />
    <circle cx="15" cy="6.5" r="3" />
  </Svg>
);

export const IconReport = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
    <path d="M8 15.5v-3M12 15.5v-6M16 15.5v-4" />
  </Svg>
);

export const IconCustomers = (p) => (
  <Svg {...p}>
    <circle cx="11" cy="8" r="3.4" />
    <path d="M4.5 20c0-3.4 2.9-5.8 6.5-5.8s6.5 2.4 6.5 5.8" />
    <path d="M17.5 4.6a3.2 3.2 0 0 1 0 6" />
  </Svg>
);

export const IconGlobe = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M3.5 12h17" />
    <path d="M12 3.5c2.2 2.4 3.3 5.3 3.3 8.5S14.2 18.1 12 20.5c-2.2-2.4-3.3-5.3-3.3-8.5S9.8 5.9 12 3.5Z" />
  </Svg>
);

export const IconSettings = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 14.5a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1Z" />
  </Svg>
);

export const IconPower = (p) => (
  <Svg {...p}>
    <path d="M12 3.5v8" />
    <path d="M7 6.3a8 8 0 1 0 10 0" />
  </Svg>
);

/* ── header + chrome ─────────────────────────────────────────────────── */

export const IconSearch = (p) => (
  <Svg {...p}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="m16 16 4 4" />
  </Svg>
);

export const IconEye = (p) => (
  <Svg {...p}>
    <path d="M3.5 12s3.1-5.5 8.5-5.5 8.5 5.5 8.5 5.5-3.1 5.5-8.5 5.5S3.5 12 3.5 12Z" />
    <circle cx="12" cy="12" r="2.5" />
  </Svg>
);

export const IconEyeOff = (p) => (
  <Svg {...p}>
    <path d="m4 4 16 16" />
    <path d="M9.5 7a8.8 8.8 0 0 1 2.5-.5c5.4 0 8.5 5.5 8.5 5.5a13 13 0 0 1-2.1 2.8" />
    <path d="M6.1 8.3A14.3 14.3 0 0 0 3.5 12s3.1 5.5 8.5 5.5a8.9 8.9 0 0 0 2.7-.4" />
  </Svg>
);

export const IconBell = (p) => (
  <Svg {...p}>
    <path d="M18 15.5V10a6 6 0 1 0-12 0v5.5L4.5 18h15Z" />
    <path d="M10 21h4" />
  </Svg>
);

export const IconChevronLeft = (p) => <Svg {...p}><path d="m14.5 5-7 7 7 7" /></Svg>;
export const IconChevronRight = (p) => <Svg {...p}><path d="m9.5 5 7 7-7 7" /></Svg>;
export const IconChevronDown = (p) => <Svg {...p}><path d="m5 9 7 7 7-7" /></Svg>;

export const IconCalendar = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
    <path d="M8 3.5V6M16 3.5V6M3.5 9.5h17" />
  </Svg>
);

/* ── appointment card ────────────────────────────────────────────────── */

export const IconGuest = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="6.5" r="3" />
    <path d="M5.5 20c0-3.2 2.9-5.5 6.5-5.5s6.5 2.3 6.5 5.5" />
    <path d="M8 11.5 5.5 20M16 11.5 18.5 20" />
  </Svg>
);

export const IconClock = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7v5.3l3.2 2" />
  </Svg>
);

export const IconPin = (p) => (
  <Svg {...p}>
    <path d="M12 21s6.5-5.6 6.5-10.4A6.5 6.5 0 0 0 5.5 10.6C5.5 15.4 12 21 12 21Z" />
    <circle cx="12" cy="10.5" r="2.4" />
  </Svg>
);

export const IconLink = (p) => (
  <Svg {...p}>
    <path d="M10 13.5a3.6 3.6 0 0 0 5.2.3l2.6-2.6a3.6 3.6 0 0 0-5.1-5.1l-1.5 1.5" />
    <path d="M14 10.5a3.6 3.6 0 0 0-5.2-.3l-2.6 2.6a3.6 3.6 0 0 0 5.1 5.1l1.5-1.5" />
  </Svg>
);

export const IconHourglass = (p) => (
  <Svg {...p}>
    <path d="M7 3.5h10M7 20.5h10" />
    <path d="M8 3.5v3.2c0 2 4 3.9 4 5.3 0 1.4-4 3.3-4 5.3v3.2" />
    <path d="M16 3.5v3.2c0 2-4 3.9-4 5.3 0 1.4 4 3.3 4 5.3v3.2" />
  </Svg>
);

export const IconDots = ({ size = 16, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" {...rest}>
    <circle cx="5.5" cy="12" r="1.8" />
    <circle cx="12" cy="12" r="1.8" />
    <circle cx="18.5" cy="12" r="1.8" />
  </svg>
);

export const IconDownload = (p) => (
  <Svg {...p}>
    <path d="M12 3.5v11" />
    <path d="m7.5 10.5 4.5 4.5 4.5-4.5" />
    <path d="M4.5 19.5h15" />
  </Svg>
);

export const IconPrinter = (p) => (
  <Svg {...p}>
    <path d="M7 8.5V3.5h10v5" />
    <path d="M7 17.5H5a1.5 1.5 0 0 1-1.5-1.5v-5A1.5 1.5 0 0 1 5 9.5h14a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-2" />
    <rect x="7" y="14" width="10" height="6.5" rx="1" />
  </Svg>
);

export const IconPlusCircle = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 8.5v7M8.5 12h7" />
  </Svg>
);

export const IconCrown = (p) => (
  <Svg {...p}>
    <path d="M4 17.5h16" />
    <path d="M4 17.5 3 7l5 3.5L12 4.5l4 6L21 7l-1 10.5" />
  </Svg>
);

export const IconCake = (p) => (
  <Svg {...p}>
    <path d="M4.5 20.5h15v-5a2 2 0 0 0-2-2h-11a2 2 0 0 0-2 2Z" />
    <path d="M4.5 16.5c1.6 1.4 3.4 1.4 5 0s3.4-1.4 5 0 3.4 1.4 5 0" />
    <path d="M8.5 10.5V8M12 10.5V7.5M15.5 10.5V8" />
  </Svg>
);

/* The glyph inside their ประเภท chip on ประวัติ. */
export const IconTag = (p) => (
  <Svg {...p}>
    <path d="M11.6 3.5H4.5a1 1 0 0 0-1 1v7.1a1 1 0 0 0 .3.7l7.9 7.9a1 1 0 0 0 1.4 0l7.1-7.1a1 1 0 0 0 0-1.4l-7.9-7.9a1 1 0 0 0-.7-.3Z" />
    <path d="M7.8 7.8h.01" />
  </Svg>
);

export const IconEdit = (p) => (
  <Svg {...p}>
    <path d="M4 20h4L19.5 8.5a2.1 2.1 0 0 0-3-3L5 17v3Z" />
    <path d="M14.5 6.5l3 3" />
  </Svg>
);

export const IconTrash = (p) => (
  <Svg {...p}>
    <path d="M4.5 6.5h15" />
    <path d="M9.5 6.5V4.8a1.3 1.3 0 0 1 1.3-1.3h2.4a1.3 1.3 0 0 1 1.3 1.3v1.7" />
    <path d="M6.5 6.5 7.4 19a1.5 1.5 0 0 0 1.5 1.4h6.2a1.5 1.5 0 0 0 1.5-1.4l.9-12.5" />
    <path d="M10.5 10v6.5M13.5 10v6.5" />
  </Svg>
);

export const IconMessage = (p) => (
  <Svg {...p}>
    <path d="M4 5.5h16v11H9l-5 4v-15Z" />
    <path d="M8 9.5h8M8 12.5h5" />
  </Svg>
);

export const IconUser = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="3.6" />
    <path d="M4.8 20.2a7.4 7.4 0 0 1 14.4 0" />
  </Svg>
);

export const IconLogout = (p) => (
  <Svg {...p}>
    <path d="M14.5 4.5h3a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-3" />
    <path d="M10 8.5 6.5 12 10 15.5" />
    <path d="M6.5 12H15" />
  </Svg>
);

export const IconKey = (p) => (
  <Svg {...p}>
    <circle cx="8" cy="12" r="3.5" />
    <path d="M11.5 12H20" />
    <path d="M17 12v3M14 12v2.5" />
  </Svg>
);

/** The six-dot drag handle used on the roster. */
export const IconGrip = ({ size = 18, ...p }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" {...p}>
    {[8, 12, 16].map((cy) => [9, 15].map((cx) => (
      <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="1.5" />
    )))}
  </svg>
);

export const IconCamera = (p) => (
  <Svg {...p}>
    <path d="M3.5 8.5h3l1.4-2.2a1.5 1.5 0 0 1 1.3-.7h3.6a1.5 1.5 0 0 1 1.3.7l1.4 2.2h3a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 2 17.5V10a1.5 1.5 0 0 1 1.5-1.5Z" />
    <circle cx="12" cy="13.5" r="3.2" />
  </Svg>
);

export const IconCheck = (p) => (
  <Svg {...p}><path d="m5 12.5 4.5 4.5L19 7.5" /></Svg>
);

export const IconKeypad = (p) => (
  <Svg {...p}>
    <rect x="2.5" y="6.5" width="19" height="11" rx="2" />
    <path d="M6 10h.01M9.5 10h.01M13 10h.01M16.5 10h.01M7.5 13.5h9" />
  </Svg>
);

export const IconCopy = (p) => (
  <Svg {...p}>
    <rect x="8.5" y="8.5" width="11" height="11" rx="2" />
    <path d="M15.5 8.5v-2a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2" />
  </Svg>
);

export const IconSave = (p) => (
  <Svg {...p}>
    <path d="M5 4.5h11L19.5 8v11.5a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1Z" />
    <path d="M8 4.5v5h7v-5M8 20.5v-6h8v6" />
  </Svg>
);

export const IconStore = (p) => (
  <Svg {...p}>
    <path d="M4 9.5V19a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 20 19V9.5" />
    <path d="M3 9.5 4.7 5a1.5 1.5 0 0 1 1.4-1h11.8a1.5 1.5 0 0 1 1.4 1L21 9.5a2.5 2.5 0 0 1-4.5 1.5 2.5 2.5 0 0 1-4.5 0 2.5 2.5 0 0 1-4.5 0A2.5 2.5 0 0 1 3 9.5Z" />
  </Svg>
);

export const IconInfo = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 11v5.5M12 8h.01" />
  </Svg>
);

export const IconProduct = (p) => (
  <Svg {...p}>
    <path d="m4 8 8-4.5L20 8v8l-8 4.5L4 16Z" />
    <path d="m4 8 8 4.5L20 8M12 12.5v8" />
    <path d="m8 5.8 8 4.5" />
  </Svg>
);

export const IconTreatment = (p) => (
  <Svg {...p}>
    <circle cx="6.5" cy="10" r="2.3" />
    <path d="M9 10h7.5a3 3 0 0 1 3 3v2.5H4.5V13" />
    <path d="M3.5 19.5v-4h17v4M7 15.5v-2.2M17 15.5v-2.2" />
  </Svg>
);

/* ── รายงาน ──────────────────────────────────────────────────────────── */

/** ค่ามือหมอนวด — a note held in the hand. */
export const IconHandCash = (p) => (
  <Svg {...p}>
    <g transform="rotate(-20 14 7.2)">
      <rect x="8.2" y="3" width="11.4" height="7.3" rx="1.6" />
      <circle cx="13.9" cy="6.7" r="1.6" />
    </g>
    <path d="M4 13.8v4a3.2 3.2 0 0 0 3.2 3.2h1.6a3.2 3.2 0 0 0 3.2-3.2v-2.4" />
    <path d="M6.4 15.4v-1.7M8.8 15.4v-2.1M11.1 15.4v-1.4" />
  </Svg>
);

/** ส่วนลด — a torn-edge slip carrying a percent. */
export const IconDiscount = (p) => (
  <Svg {...p}>
    <path d="M5.5 4.6 8 3.4l2.5 1.2L13 3.4l2.5 1.2L18 3.4v17.2l-2.5-1.2-2.5 1.2-2.5-1.2L8 20.6l-2.5-1.2Z" />
    <path d="m9.8 14.2 4.4-4.4" />
    <circle cx="9.9" cy="10" r="1" />
    <circle cx="14.1" cy="14" r="1" />
  </Svg>
);

/** ค่าคอมเอเจนซี่ — money leaving the till. */
export const IconMoneyUp = (p) => (
  <Svg {...p}>
    <path d="M9.6 8.5H5.2a1.7 1.7 0 0 0-1.7 1.7v7.6a1.7 1.7 0 0 0 1.7 1.7h13.6a1.7 1.7 0 0 0 1.7-1.7v-7.6a1.7 1.7 0 0 0-1.7-1.7h-4.4" />
    <circle cx="12" cy="14" r="2.1" />
    <path d="M12 10.2V3.6" />
    <path d="m9.5 6.1 2.5-2.5 2.5 2.5" />
    <path d="M6.6 11.4h.01M17.4 16.6h.01" />
  </Svg>
);

/** รายจ่ายแคชเชียร์ — the counter stamp. */
export const IconStamp = (p) => (
  <Svg {...p}>
    <rect x="9.6" y="3.5" width="4.8" height="4.6" rx="1.6" />
    <path d="M12 8.1v2.4" />
    <path d="M6.6 17v-3.2a2 2 0 0 1 2-2h6.8a2 2 0 0 1 2 2V17" />
    <rect x="4.5" y="17" width="15" height="3.5" rx="1.2" />
  </Svg>
);

export const IconThumbUp = (p) => (
  <Svg {...p}>
    <path d="M8 20.4h8a2.2 2.2 0 0 0 2.2-1.9l.9-5.3a1.9 1.9 0 0 0-1.9-2.2h-4.3V6.5a2 2 0 0 0-3.8-.9L8 10.6Z" />
    <path d="M8 10.6H5.4a1.2 1.2 0 0 0-1.2 1.2v7.4a1.2 1.2 0 0 0 1.2 1.2H8Z" />
  </Svg>
);

export const IconDollarCircle = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.3" />
    <path d="M14.5 9.4a2.3 2.3 0 0 0-2.1-1.3h-.9a1.9 1.9 0 0 0-.3 3.8h1.6a1.9 1.9 0 0 1-.3 3.8h-.9a2.3 2.3 0 0 1-2.1-1.3" />
    <path d="M12 6.6v10.8" />
  </Svg>
);

export const IconQr = (p) => (
  <Svg {...p}>
    <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4z" />
    <path d="M14 14h2v2h-2zM18 14h2v4h-2zM14 18h4v2h-4zM20 20h.01" />
  </Svg>
);

export const IconCreditCard = (p) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path d="M3 9h18M7 15h4" />
  </Svg>
);

export const IconExternal = (p) => (
  <Svg {...p}>
    <path d="M14.5 4.5h5v5" />
    <path d="m19.5 4.5-7.5 7.5" />
    <path d="M18 14v4.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 18.5v-11A1.5 1.5 0 0 1 5.5 6H10" />
  </Svg>
);
